import { AfterViewInit, Component, HostBinding, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EntityType } from 'src/app/enums/entity-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { FieldsListsService } from 'src/app/services/fields-lists.service';
import { LanguageService } from 'src/app/services/language.service';
import { MenuItemsService } from 'src/app/services/menu-items.service';
import { RoutingService } from 'src/app/services/routing.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  @HostBinding('attr.lang') lang: string | undefined;
  entityPage: string = '';
  uniqueUri: string | null = null;
  copied = false;
  EntityType = EntityType;
  closeClicked: Subject<void> = new Subject<void>();
  currentLanguage$!: Observable<string>;

  constructor(private routingService: RoutingService,
    private fieldsListsService: FieldsListsService,
    private menuItemsService: MenuItemsService,
    private languageService: LanguageService,
    private apiService: ApiService) { }

  copyToClipboard(text: string | null): void {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }

  ngOnInit(): void {
    this.currentLanguage$ = this.languageService.currentLanguage$;
    this.routingService.entityDetails$.subscribe((entityDetails: { type: string, id: number }) => {
      this.entityPage = this.getEntityPage(entityDetails.type);
      this.uniqueUri = null;
      if (entityDetails.id) {
        this.apiService.getUniqueUriByEntityId(entityDetails.id).subscribe({
          next: (uri) => this.uniqueUri = uri,
          error: () => this.uniqueUri = null
        });
      }
      if (this.entityPage === '') {
        const elem = this.menuItemsService.getLastFocusedElement();
        if (elem !== null && elem.target !== null) {
          setTimeout(() => { elem.target.focus(); }, 0);
          this.menuItemsService.setLastFocusedElement(null);
        }
      }
    });
    this.fieldsListsService.loadAllFields();
  }

  private getEntityPage(entityType: string): string {
    switch (entityType) {
      case EntityType.LOCUS:
      case EntityType.BASKET:
        return EntityType.LOCUS;
      case EntityType.OBJECT:
        return EntityType.OBJECT;
      case EntityType.COIN:
        return EntityType.COIN;
      case EntityType.EXCAVATION:
        return EntityType.EXCAVATION;
      case EntityType.SURVEY:
        return EntityType.SURVEY;
      case EntityType.HACHRAZA:
        return EntityType.HACHRAZA;
      case EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS:
        return EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS;
      case EntityType.SCIENTIFIC_ARCHIVE_FOLDERS:
        return EntityType.SCIENTIFIC_ARCHIVE_FOLDERS;
      case EntityType.CONSERVATION_ARCHIVE_DOCUMENTS:
        return EntityType.CONSERVATION_ARCHIVE_DOCUMENTS;
      case EntityType.CONSERVATION_ARCHIVE_FOLDERS:
        return EntityType.CONSERVATION_ARCHIVE_FOLDERS;
      case EntityType.FRAGMENT:
        return EntityType.FRAGMENT;
      case EntityType.MANUSCRIPT:
        return EntityType.MANUSCRIPT;
      case EntityType.ORTHOPHOTO:
        return EntityType.ORTHOPHOTO;
      case EntityType.PHOTOGRAMMETRIC:
        return EntityType.PHOTOGRAMMETRIC;
      case EntityType.PLASTER_SAMPLE:
        return EntityType.PLASTER_SAMPLE;
      case EntityType.HB_SECTION:
        return EntityType.HB_SECTION;
      default:
        return '';
    }
  }
  onCloseEntityPage(): void {
    this.closeClicked.next();
    this.routingService.resetEntityDetails();
  }
}